var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1679_85746",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9883 0.0175781H0V23.9708H23.9883V0.0175781Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1679_85746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1101 23.9708H9.7441C5.42347 23.9708 1.9209 20.4734 1.9209 16.159V2.03293C1.9209 0.919992 2.82463 0.0175781 3.93919 0.0175781H20.1101C21.2249 0.0175781 22.1286 0.919992 22.1286 2.03293V21.9554C22.1286 23.0684 21.2249 23.9708 20.1101 23.9708Z",
    fill: "#BCE4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9089 5.01767H7.06282C6.86864 5.01767 6.71143 4.86051 6.71143 4.6668C6.71143 4.47308 6.86864 4.31592 7.06282 4.31592H16.9089C17.1031 4.31592 17.2603 4.47308 17.2603 4.6668C17.2603 4.86051 17.1031 5.01767 16.9089 5.01767Z",
    fill: "#747679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.085 7.40341H5.94969C5.71036 7.40341 5.5166 7.24643 5.5166 7.05254C5.5166 6.85882 5.71036 6.70166 5.94969 6.70166H18.085C18.3243 6.70166 18.5181 6.85882 18.5181 7.05254C18.5181 7.24643 18.3243 7.40341 18.085 7.40341Z",
    fill: "#747679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3841 9.78964H8.57405C8.37987 9.78964 8.22266 9.63249 8.22266 9.43877C8.22266 9.24487 8.37987 9.08789 8.57405 9.08789H15.3841C15.5783 9.08789 15.7355 9.24487 15.7355 9.43877C15.7355 9.63249 15.5783 9.78964 15.3841 9.78964Z",
    fill: "#747679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9089 14.5616H7.06282C6.86864 14.5616 6.71143 14.4045 6.71143 14.2107C6.71143 14.017 6.86864 13.8599 7.06282 13.8599H16.9089C17.1031 13.8599 17.2603 14.017 17.2603 14.2107C17.2603 14.4045 17.1031 14.5616 16.9089 14.5616Z",
    fill: "#747679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.085 12.1754H5.94969C5.71036 12.1754 5.5166 12.0184 5.5166 11.8245C5.5166 11.6308 5.71036 11.4736 5.94969 11.4736H18.085C18.3243 11.4736 18.5181 11.6308 18.5181 11.8245C18.5181 12.0184 18.3243 12.1754 18.085 12.1754Z",
    fill: "#747679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3841 16.9474H8.57405C8.37987 16.9474 8.22266 16.7902 8.22266 16.5965C8.22266 16.4026 8.37987 16.2456 8.57405 16.2456H15.3841C15.5783 16.2456 15.7355 16.4026 15.7355 16.5965C15.7355 16.7902 15.5783 16.9474 15.3841 16.9474Z",
    fill: "#747679"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.32096 17.7217H5.69815C4.28145 17.7217 2.92273 17.1596 1.9209 16.1592C1.9209 20.4735 5.42347 23.971 9.7441 23.971C8.74229 22.9706 8.17932 21.6139 8.17932 20.1992V19.5773C8.17932 18.5525 7.34733 17.7217 6.32096 17.7217Z",
    fill: "#A6DEFB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.5f886e8c396dc6e98061ab352017054a.svg";
export { ForwardRef as ReactComponent };